<script context="module">
import {apiUrl} from '../config.svelte';
export let doLogin = (callback,login,password)=>{
        fetch(apiUrl+"login",{
            credentials: "include",
            method:"POST",
            body:JSON.stringify({login:login,password:password}),
            cors:'no-cors'
        })
        .then(x=>x.json())
        .then(x=>{
           callback(x)
        })
        .catch((e)=>{
            console.log("error",e)
            callback({result:false,user:{}})
        })
    }

</script>